import React from "react";
import '../assets/css/index.css'
import '../assets/css/app.css'
import '../assets/css/custom.css'
import '../assets/css/base.css'
import Layout from "../layout";
import {useEvent} from "socket.io-react-hooks-advanced";
import {useDispatch} from "react-redux";
import {setDrawingResult} from "../redux/actions/resultActions";

const App = () => {
    const dispatch = useDispatch();

    useEvent("tns_result", (msg) => {
        console.log(msg, "msg")
        dispatch(setDrawingResult(msg));
    });

    return <Layout/>
}
export default App;
